import { Language } from '@ha/intl';

export const STATE_NAME = 'hermes';

export const ContentfulSupportedLangs: Language[] = [
  Language.en,
  Language.fr,
  Language.de,
  Language.es,
  Language.it,
  Language.nl,
];
export const AnswersSupportedLangs: Language[] = [
  Language.en,
  Language.fr,
  Language.de,
  Language.es,
  Language.it,
  Language.nl,
  Language.pl,
  Language.pt,
  Language.ru,
  Language.ro,
  Language.sv,
];
